/**
 *   Generated file. Do not edit
 */

import { LoginCredential } from './models';
import { LoginCredentialHashed } from './models';
import { HostProtocol } from '@iotize/tap';
import { SecurityOptions } from './models';
import { NfcPairingMode } from './models';
import { WirelessPairingOptions } from './models';
import { LowPowerOptimizationLevel } from './models';
import { CpuFrequencyOptions } from './models';
import { CpuFrequencySpeed } from '@iotize/tap';
import { PowerOptimizationOptions } from './models';
import { ServiceCode } from './models';
import { NetworkOptions } from './models';
import { NfcConnectionPriority } from './models';
import { ProtocolMaxFrameSize } from './models';
import { MultiRequestFrame } from './models';
import { MultiResponseFrame } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';
import { TapRequestFrame } from '@iotize/tap/client/api';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readLoginCredential(): LoginCredential;

    readLoginCredentialHashed(): LoginCredentialHashed;

    readSecurityOptions(): SecurityOptions;

    readWirelessPairingOptions(): WirelessPairingOptions;

    readCpuFrequencyOptions(): CpuFrequencyOptions;

    readPowerOptimizationOptions(): PowerOptimizationOptions;

    readNetworkOptions(): NetworkOptions;

    readProtocolMaxFrameSize(): ProtocolMaxFrameSize;

    readMultiRequestFrame(): MultiRequestFrame;

    readMultiRequestFrameRequestItem(): MultiRequestFrame.RequestItem;

    readMultiResponseFrame(): MultiResponseFrame;

    readMultiResponseFrameResponseItem(): MultiResponseFrame.ResponseItem;
  }
  export interface TapStreamWriter {
    writeLoginCredential(model: LoginCredential): TapStreamWriter;

    writeLoginCredentialHashed(model: LoginCredentialHashed): TapStreamWriter;

    writeSecurityOptions(model: SecurityOptions): TapStreamWriter;

    writeWirelessPairingOptions(model: WirelessPairingOptions): TapStreamWriter;

    writeCpuFrequencyOptions(model: CpuFrequencyOptions): TapStreamWriter;

    writePowerOptimizationOptions(
      model: PowerOptimizationOptions,
    ): TapStreamWriter;

    writeNetworkOptions(model: NetworkOptions): TapStreamWriter;

    writeProtocolMaxFrameSize(model: ProtocolMaxFrameSize): TapStreamWriter;

    writeMultiRequestFrame(model: MultiRequestFrame): TapStreamWriter;

    writeMultiRequestFrameRequestItem(
      model: MultiRequestFrame.RequestItem,
    ): TapStreamWriter;

    writeMultiResponseFrame(model: MultiResponseFrame): TapStreamWriter;

    writeMultiResponseFrameResponseItem(
      model: MultiResponseFrame.ResponseItem,
    ): TapStreamWriter;
  }
}

TapStreamReader.prototype.readLoginCredential = function (): LoginCredential {
  const model: Partial<LoginCredential> = {};

  model.username = this.readString(16);

  model.password = this.readString(16);

  return model as LoginCredential;
};

TapStreamReader.prototype.readLoginCredentialHashed =
  function (): LoginCredentialHashed {
    const model: Partial<LoginCredentialHashed> = {};

    model.username = this.readString(16);

    model.password = this.readBytes(16);

    return model as LoginCredentialHashed;
  };

TapStreamReader.prototype.readSecurityOptions = function (): SecurityOptions {
  const model: Partial<SecurityOptions> = {};

  this.forwardBits(8);

  this.forwardBits(2);

  model.maxWakeUpTimeActivated = this.readBoolean(1);

  model.scramActivated = this.readBoolean(1);

  model.hashPassword = this.readBoolean(1);

  model.disableHardwareFactoryReset = this.readBoolean(1);

  model.disableLoginWithUID = this.readBoolean(1);

  model.disableResourceFactoryReset = this.readBoolean(1);

  return model as SecurityOptions;
};

TapStreamReader.prototype.readWirelessPairingOptions =
  function (): WirelessPairingOptions {
    const model: Partial<WirelessPairingOptions> = {};

    this.forwardBits(5);

    model.blePairing = this.readBoolean(1);

    model.nfcPairingMode = this.readBits(2);

    return model as WirelessPairingOptions;
  };

TapStreamReader.prototype.readCpuFrequencyOptions =
  function (): CpuFrequencyOptions {
    const model: Partial<CpuFrequencyOptions> = {};

    this.forwardBits(6);

    model.speed = this.readBits(2);

    return model as CpuFrequencyOptions;
  };

TapStreamReader.prototype.readPowerOptimizationOptions =
  function (): PowerOptimizationOptions {
    const model: Partial<PowerOptimizationOptions> = {};

    this.forwardBits(4);

    model.cpuFrequencySpeed = this.readBits(2);

    model.lowPowerOptimizationLevel = this.readBits(2);

    return model as PowerOptimizationOptions;
  };

TapStreamReader.prototype.readNetworkOptions = function (): NetworkOptions {
  const model: Partial<NetworkOptions> = {};

  this.forwardBits(3);

  model.radioMixEnabled = this.readBoolean(1);

  model.lteEnabled = this.readBoolean(1);

  model.ethernetEnabled = this.readBoolean(1);

  model.wifiDisabled = this.readBoolean(1);

  model.wifiNetworkMode = this.readBoolean(1);

  return model as NetworkOptions;
};

TapStreamReader.prototype.readProtocolMaxFrameSize =
  function (): ProtocolMaxFrameSize {
    const model: Partial<ProtocolMaxFrameSize> = {};

    model.request = this.readUnsigned(2);

    model.response = this.readUnsigned(2);

    return model as ProtocolMaxFrameSize;
  };

TapStreamReader.prototype.readMultiRequestFrame =
  function (): MultiRequestFrame {
    const model: Partial<MultiRequestFrame> = {};

    model.requests = [];
    while (!this.isEof()) {
      model.requests!.push(this.readMultiRequestFrameRequestItem());
    }

    return model as MultiRequestFrame;
  };

TapStreamReader.prototype.readMultiRequestFrameRequestItem =
  function (): MultiRequestFrame.RequestItem {
    const model: Partial<MultiRequestFrame.RequestItem> = {};

    model.requestLen = this.readUnsigned(2);

    model.request = this.subStream(model.requestLen).readTapRequestFrame();

    model.expectedResponseStatus = this.readUnsigned(1);

    return model as MultiRequestFrame.RequestItem;
  };

TapStreamReader.prototype.readMultiResponseFrame =
  function (): MultiResponseFrame {
    const model: Partial<MultiResponseFrame> = {};

    model.responses = [];
    while (!this.isEof()) {
      model.responses!.push(this.readMultiResponseFrameResponseItem());
    }

    return model as MultiResponseFrame;
  };

TapStreamReader.prototype.readMultiResponseFrameResponseItem =
  function (): MultiResponseFrame.ResponseItem {
    const model: Partial<MultiResponseFrame.ResponseItem> = {};

    model.responseLen = this.readUnsigned(2);

    model.response = this.subStream(model.responseLen).readTapResponseFrame();

    return model as MultiResponseFrame.ResponseItem;
  };

// TapStreamWriter.prototype.write(model: LoginCredential) : TapStreamWriter{
//     return this.writeLoginCredential(model)
// }

TapStreamWriter.prototype.writeLoginCredential = function (
  model: LoginCredential,
): TapStreamWriter {
  this.writeString(model.username, 16);

  this.writeString(model.password, 16);

  return this;
};

// TapStreamWriter.prototype.write(model: LoginCredentialHashed) : TapStreamWriter{
//     return this.writeLoginCredentialHashed(model)
// }

TapStreamWriter.prototype.writeLoginCredentialHashed = function (
  model: LoginCredentialHashed,
): TapStreamWriter {
  this.writeString(model.username, 16);

  this.writeBytes(model.password, 16);

  return this;
};

// TapStreamWriter.prototype.write(model: SecurityOptions) : TapStreamWriter{
//     return this.writeSecurityOptions(model)
// }

TapStreamWriter.prototype.writeSecurityOptions = function (
  model: SecurityOptions,
): TapStreamWriter {
  this.forwardBits(8);

  this.forwardBits(2);

  this.writeBoolean(model.maxWakeUpTimeActivated, 1);

  this.writeBoolean(model.scramActivated, 1);

  this.writeBoolean(model.hashPassword, 1);

  this.writeBoolean(model.disableHardwareFactoryReset, 1);

  this.writeBoolean(model.disableLoginWithUID, 1);

  this.writeBoolean(model.disableResourceFactoryReset, 1);

  return this;
};

// TapStreamWriter.prototype.write(model: WirelessPairingOptions) : TapStreamWriter{
//     return this.writeWirelessPairingOptions(model)
// }

TapStreamWriter.prototype.writeWirelessPairingOptions = function (
  model: WirelessPairingOptions,
): TapStreamWriter {
  this.forwardBits(5);

  this.writeBoolean(model.blePairing, 1);

  this.writeBitsInt(
    enumKeyOrValueToNumber<WirelessPairingOptions.NfcPairingMode>(
      model.nfcPairingMode,
      WirelessPairingOptions.NfcPairingMode,
    ),
    2,
  );

  return this;
};

// TapStreamWriter.prototype.write(model: CpuFrequencyOptions) : TapStreamWriter{
//     return this.writeCpuFrequencyOptions(model)
// }

TapStreamWriter.prototype.writeCpuFrequencyOptions = function (
  model: CpuFrequencyOptions,
): TapStreamWriter {
  this.forwardBits(6);

  this.writeBitsInt(
    enumKeyOrValueToNumber<CpuFrequencySpeed>(model.speed, CpuFrequencySpeed),
    2,
  );

  return this;
};

// TapStreamWriter.prototype.write(model: PowerOptimizationOptions) : TapStreamWriter{
//     return this.writePowerOptimizationOptions(model)
// }

TapStreamWriter.prototype.writePowerOptimizationOptions = function (
  model: PowerOptimizationOptions,
): TapStreamWriter {
  this.forwardBits(4);

  this.writeBitsInt(
    enumKeyOrValueToNumber<CpuFrequencySpeed>(
      model.cpuFrequencySpeed,
      CpuFrequencySpeed,
    ),
    2,
  );

  this.writeBitsInt(
    enumKeyOrValueToNumber<LowPowerOptimizationLevel>(
      model.lowPowerOptimizationLevel,
      LowPowerOptimizationLevel,
    ),
    2,
  );

  return this;
};

// TapStreamWriter.prototype.write(model: NetworkOptions) : TapStreamWriter{
//     return this.writeNetworkOptions(model)
// }

TapStreamWriter.prototype.writeNetworkOptions = function (
  model: NetworkOptions,
): TapStreamWriter {
  this.forwardBits(3);

  this.writeBoolean(
    model.radioMixEnabled !== undefined ? model.radioMixEnabled : 0,
    1,
  );

  this.writeBoolean(model.lteEnabled !== undefined ? model.lteEnabled : 0, 1);

  this.writeBoolean(
    model.ethernetEnabled !== undefined ? model.ethernetEnabled : 0,
    1,
  );

  this.writeBoolean(
    model.wifiDisabled !== undefined ? model.wifiDisabled : 0,
    1,
  );

  this.writeBoolean(
    model.wifiNetworkMode !== undefined ? model.wifiNetworkMode : 0,
    1,
  );

  return this;
};

// TapStreamWriter.prototype.write(model: ProtocolMaxFrameSize) : TapStreamWriter{
//     return this.writeProtocolMaxFrameSize(model)
// }

TapStreamWriter.prototype.writeProtocolMaxFrameSize = function (
  model: ProtocolMaxFrameSize,
): TapStreamWriter {
  this.writeUnsigned(model.request, 2);

  this.writeUnsigned(model.response, 2);

  return this;
};

// TapStreamWriter.prototype.write(model: MultiRequestFrame) : TapStreamWriter{
//     return this.writeMultiRequestFrame(model)
// }

TapStreamWriter.prototype.writeMultiRequestFrame = function (
  model: MultiRequestFrame,
): TapStreamWriter {
  for (let item of model.requests) {
    this.writeMultiRequestFrameRequestItem(item);
  }

  return this;
};

TapStreamWriter.prototype.writeMultiRequestFrameRequestItem = function (
  model: MultiRequestFrame.RequestItem,
): TapStreamWriter {
  this.writeUnsigned(model.requestLen, 2);

  this.writeTapRequestFrame(model.request);

  this.writeUnsigned(model.expectedResponseStatus, 1);

  return this;
};

// TapStreamWriter.prototype.write(model: MultiResponseFrame) : TapStreamWriter{
//     return this.writeMultiResponseFrame(model)
// }

TapStreamWriter.prototype.writeMultiResponseFrame = function (
  model: MultiResponseFrame,
): TapStreamWriter {
  for (let item of model.responses) {
    this.writeMultiResponseFrameResponseItem(item);
  }

  return this;
};

TapStreamWriter.prototype.writeMultiResponseFrameResponseItem = function (
  model: MultiResponseFrame.ResponseItem,
): TapStreamWriter {
  this.writeUnsigned(model.responseLen, 2);

  this.writeTapResponseFrame(model.response);

  return this;
};
